import { useQuery, Query, useQueryClient, QueryOptions, QueryResult } from '@eika-infrastruktur/react-query';

import type { AccountNumber, PaymentItem } from '../generated-types';
import { getPaymentItems } from '../services/paymentService';

export const FUTURE_PAYMENTS_KEY = 'futurePayments';

export const useAllFuturePayments = (options: Partial<QueryOptions<PaymentItem[]>> = {}): QueryResult<PaymentItem[]> =>
    useQuery({
        ...options,
        queryKey: [FUTURE_PAYMENTS_KEY],
        queryFn: () => getPaymentItems('PENDING_PAYMENT'),
    });

const useFuturePayments = (accountNumber?: AccountNumber): QueryResult<PaymentItem[]> =>
    useAllFuturePayments({
        select: (payments) => payments.filter((payment) => payment.from?.accountNumber?.value === accountNumber?.value),
        enabled: !!accountNumber,
    });

export const useRefreshFuturePayments = () => {
    const queryClient = useQueryClient();

    const futurePaymentKeys = [FUTURE_PAYMENTS_KEY];

    const predicate = (query: Query): boolean => futurePaymentKeys.some((a) => a === query.queryKey[0]);

    return () => {
        queryClient.cancelQueries({ predicate });
        queryClient.invalidateQueries({ predicate });
    };
};

export default useFuturePayments;
